export const SET_MISSING_VALUES_FOR_INPUT = 'searchConditions/SET_MISSING_VALUES_FOR_INPUT';
export const RESET_MISSING_VALUES = 'searchConditions/RESET_MISSING_VALUES';
